import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Field from 'components/AddOrEditFormPage/CustomForm/Field'
// import FieldCheckbox from 'components/AddOrEditFormPage/CustomForm/FieldCheckbox'
import { handleSectionValueChange } from 'actions/customForm/addOrEdit'

const NumberOptions = connect(null, (dispatch) =>
	bindActionCreators({ handleSectionValueChange }, dispatch),
)(({ handleSectionValueChange, itemID }) => {
	return (
		<div>
			<Field
				handleChange={({ property, value, type, id }) =>
					handleSectionValueChange({
						property,
						value: { decimal_places: value || 0 },
						type,
						id,
					})
				}
				label="Decimal places*"
				property="number_options"
				statePath={(state) => {
					const statePath =
						state.customForm.addOrEdit.sectionsByID?.[itemID]?.field
							?.number_options?.decimal_places

					return statePath
				}}
				placeholder="Enter a number of allowed decimal places"
				type="field"
				sectionID={itemID}
				fieldType="int"
			/>
			<Field
				handleChange={({ property, value, type, id }) =>
					handleSectionValueChange({
						property,
						value: { max_value: parseFloat(value) || value || undefined },
						type,
						id,
					})
				}
				label="Max value"
				property="number_options"
				statePath={(state) => {
					const statePath =
						state.customForm.addOrEdit.sectionsByID?.[itemID]?.field
							?.number_options?.max_value

					return statePath
				}}
				placeholder="Enter the maximum allowed value"
				type="field"
				sectionID={itemID}
				fieldType="float"
			/>
			<Field
				handleChange={({ property, value, type, id }) =>
					handleSectionValueChange({
						property,
						value: { min_value: parseFloat(value) || value || undefined },
						type,
						id,
					})
				}
				label="Min value"
				property="number_options"
				statePath={(state) => {
					const statePath =
						state.customForm.addOrEdit.sectionsByID?.[itemID]?.field
							?.number_options?.min_value

					return statePath
				}}
				placeholder="Enter the minimum allowed value"
				type="field"
				sectionID={itemID}
				fieldType="float"
			/>
		</div>
	)
})

export default NumberOptions
